import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Submotive3ActionsProps } from './props';
import { useSubmotive3ListActions } from './hook';

export const Submotive3ListActions = ({ id }: Submotive3ActionsProps) => {
    const { handleEdit } = useSubmotive3ListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
